import {Component, EventEmitter, inject, OnInit, Output, signal} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "projects/store/src/environments/environment";
import {LocalStorageKey, ExternalSite, SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {CustomMessageService, LocalStorageService, UtilService, OriginMessageError} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {EMPTY_TOP_UP_LOAN, TopUpLoan} from "projects/store/src/app/interfaces";
import {forkJoin} from "rxjs";


const SIM_CARD_UNLOCK_ERROR_MSG = 'No se pudo realizar el desbloqueo de la SIM Card. Por favor vuelve a intentarlo.';

@Component({
  selector: 'sales-final-message-top-up-loan',
  templateUrl: './sales-final-message-top-up-loan.component.html'
})
export class SalesFinalMessageTopUpLoanComponent implements OnInit{
  private readonly route = inject(ActivatedRoute);
  private readonly utilService = inject(UtilService);
  private requestService = inject(RequestService);
  private customMessageService = inject(CustomMessageService);
  private readonly salesWorFlowService = inject(SalesWorkflowService);
  private router = inject(Router);

  private readonly request_id = this.route.snapshot.params['request_id'];
  readonly categoryCode = this.route.snapshot.params['category_code'];
  readonly flowCode = this.route.snapshot.params['flow_code'];
  routesBreadcrumb = ['VENTAS', 'Autogestión', 'Finalizado'];
  request = this.requestService.request;

  visibleErrorSIM: boolean = false;
  visibleSuccessSIM: boolean = false;
  visibleImportantMsg: boolean = false;
  data = signal<any>({});
  isLoading = signal<boolean>(false);
  statusText = signal<string | null>(null);
  stepByFlows: any = [];
  topUpLoan: TopUpLoan = { ...EMPTY_TOP_UP_LOAN };

  ngOnInit(): void {
    this.load();
  }


  load(){
    this.utilService.enablePageLoading();
    this.data.set(this.request);

    if(this.isFlowAddressSales){
      this.visibleImportantMsg = true;
    }

    forkJoin({
      steps: this.salesWorFlowService.getStepsByFlowId(this.salesWorFlowService.workflow.id, this.requestService.categoryId),
      topUpLoan: this.requestService.getTopUpLoan(this.request_id)
    }).subscribe({
      next: ({ steps, topUpLoan }) => {
        if (steps.status === HttpStatusCode.Ok) {
          this.stepByFlows = steps.body.data.list;
          this.showUnlockSimButton();
        }

        if (topUpLoan.status === HttpStatusCode.Ok) {
          this.topUpLoan = topUpLoan.body.data;
        } else {
          this.customMessageService.responseError();
        }
      },
      error: (err: HttpErrorResponse) => {
        this.customMessageService.responseNoticeHandler(err);
        this.utilService.disablePageLoading();
      },
      complete: () => {
        this.utilService.disablePageLoading();
      }
    });
  }

  get isFlowAddressSales(): boolean {
    return this.flowCode === SalesWorkflow['domicilio-vendedor'];
  }

  showUnlockSimButton(): boolean{
    return this.stepByFlows.some( (item: { code: string; }) => item.code === SalesWorkflowSteps["phone-enrollment"] );
  }

  unlockSimCard(){
    this.isLoading.set(true);
    this.requestService.unlockSim(this.request_id).subscribe({
      next:(resp) => {
        if (resp.status == HttpStatusCode.Ok){
          this.visibleSuccessSIM = true;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.isLoading.set(false);
      },
      error: (err: HttpErrorResponse)=> {
        if( err.status === HttpStatusCode.NotAcceptable ){
          this.customMessageService.responseNoticeHandler({...err, error: { ...err.error, message: SIM_CARD_UNLOCK_ERROR_MSG}}, OriginMessageError.BACKEND, { message: SIM_CARD_UNLOCK_ERROR_MSG});
        }else{
          this.customMessageService.responseNoticeHandler(err);
        }
        this.isLoading.set(false);
      }
    })

  }

  onHomePage() {
    this.salesWorFlowService.navigateToInitial(this.flowCode)
  }

  frecuencyText(frecuency: number): string {
    return this.utilService.getFrequencyDescription(frecuency);
  }

  frecuencyTextSingular(frecuency: number): string {
    return this.utilService.getFrequencyDescription(frecuency, false, true);
  }

  get subtotalToConsolidate(): number {
    return this.topUpLoan.current_loan.balance - this.topUpLoan.consolidation.discount;
  }

  get hasAdvancePayment(): boolean {
    return this.topUpLoan.advance_payment > 0;
  }

}
